import { UnknownAttachment } from '../../AttachmentArbiter/Attachment';
import { createRenderingTracker, trackingKey } from '../createRenderingTracker';

/**
 * Why a tracker for unknown attachments?
 * "Unknown" is the catch-all bucket for resource types the report doesn't
 * know how to render natively. There's no widget today, but the tracker
 * exists so any future fallback widget gets dedup for free, and so the
 * surrounding logging/telemetry code never has to special-case "this
 * attachment type happens to lack a tracker". Identity is the FHIR
 * `ResourceType/id`.
 */
export type UnknownTrackerInput = {
  attachment: UnknownAttachment;
};

const handle = createRenderingTracker<UnknownTrackerInput>(({ attachment }) =>
  trackingKey(attachment.identifier),
);

export const UnknownTrackingProvider = handle.Provider;
export const useUnknownTracker = handle.useTracker;
